import { reverse } from 'named-urls';

import routes from 'core/routes';

export type EntitySubmissionEntityType = 'events' | 'audits';

export type BreadcrumbConfig = { label: string; link: string };

export type EntitySubmissionConfig = {
  entityType: EntitySubmissionEntityType;
  /** Singular record label, e.g. the submitted confirmation. */
  recordLabel: string;
  /** What the thing being filled in is called: Events author "form templates", audits "audit templates". */
  submissionNoun: string;
  /** Matched to derive the entity type. */
  draftRoute: string;
  /** Where Cancel and a 404 on load go. */
  listRoute: string;
  breadcrumbs: (formName: string) => BreadcrumbConfig[];
  /** A builder, not a route: Events reverses `:entityId` and audits `:formId`, and reversing one
   * with the other's param name yields a broken URL with no error. */
  recordUrl: (uuid: string) => string;
};

export const entitySubmissionConfig: Record<EntitySubmissionEntityType, EntitySubmissionConfig> = {
  events: {
    entityType: 'events',
    recordLabel: 'Event',
    submissionNoun: 'form',
    draftRoute: routes.dashboard.events.draft.details.toString(),
    listRoute: routes.dashboard.events.toString(),
    breadcrumbs: (formName) => [
      { label: 'Events', link: routes.dashboard.events.toString() },
      { label: 'Overview', link: routes.dashboard.events.toString() },
      { label: formName, link: reverse(routes.dashboard.events.draft.details) },
    ],
    recordUrl: (uuid) => reverse(routes.dashboard.events.details, { entityId: uuid }),
  },
  audits: {
    entityType: 'audits',
    recordLabel: 'Audit',
    submissionNoun: 'audit',
    draftRoute: routes.dashboard.audits.draft.details.toString(),
    listRoute: routes.dashboard.audits.forms.toString(),
    breadcrumbs: (formName) => [
      { label: 'Audits', link: routes.dashboard.audits.forms.toString() },
      { label: formName, link: reverse(routes.dashboard.audits.draft.details) },
    ],
    recordUrl: (uuid) => reverse(routes.dashboard.audits.forms.details, { formId: uuid }),
  },
};

export const getEntitySubmissionConfig = (entityType: string | null): EntitySubmissionConfig =>
  entitySubmissionConfig[(entityType as EntitySubmissionEntityType) || 'events'] || entitySubmissionConfig.events;

export const isAuditsSubmission = (entityType: string | null): boolean => entityType === 'audits';
